import { render, staticRenderFns } from "./wait_confirmed.vue?vue&type=template&id=b1bb5320&scoped=true&"
import script from "./wait_confirmed.vue?vue&type=script&lang=js&"
export * from "./wait_confirmed.vue?vue&type=script&lang=js&"
import style0 from "./wait_confirmed.vue?vue&type=style&index=0&id=b1bb5320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bb5320",
  null
  
)

export default component.exports